const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Login+API

function login({
    deviceFingerprint, login: log1n, password, options
}) {
    const {
        loginForCheckout,
        isKeepSignedIn,
        isOrderConfirmation,
        biAccountInfo,
        extraParams
    } = options;

    let body = {
        login: log1n,
        password,
        ...(isKeepSignedIn && deviceFingerprint && { deviceFingerprint })
    };


    if (isOrderConfirmation) {
        body.source = 'orderConfirmation';
        if (biAccountInfo) {
            body.isJoinBi = biAccountInfo.isJoinBi;
            body.biAccount = biAccountInfo.birthday;
            body.subscription = biAccountInfo.subscription;
        }
    } else {
        body.loginForCheckout = loginForCheckout;
        body.isKeepSignedIn = isKeepSignedIn;
    }

    if (extraParams) {
        body = {
            ...body,
            ...extraParams
        };
    }

    const url = '/api/auth/login';

    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-type': 'application/json' }
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = { login };
